import { StyleSheet, Platform } from 'react-native';

import cardShadow from '../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: {
    marginTop: Platform.OS === 'ios' ? 12 : 2,
  },
  cardContainerStyle: theme => ({
    paddingVertical: 18,
    paddingHorizontal: 16,
    marginHorizontal: 16,
    marginBottom: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    ...cardShadow,
    flexDirection: 'row',
  }),
  firstLine: {
    height: 13,
    marginBottom: 27,
  },
  secondLine: {
    height: 12,
  },
  headerContainer: {
    marginBottom: 21,
    marginHorizontal: 16,
    marginTop: 15,
  },
  settingsCardBodyItemCircle: {
    width: 33,
    height: 33,
    borderRadius: 28,
    marginRight: 18,
  },
  settingsCardBodyItemSquare: {
    width: '95%',
    height: 12.5,
  },
  settingsCardBodyItemSecondSquare: {
    width: '95%',
    height: 12.5,
    marginTop: 10,
  },
});
